var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "user_list_page" },
    [
      _vm.isDeviceModelsLoaded
        ? _c("business-group", {
            ref: "businessGroup",
            attrs: {
              tableConfig: _vm.tableConfig,
              formConfig: { ..._vm.formConfig },
              formValues: _vm.dynamicFormValues,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "tableAction",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between",
                            "align-items": "center",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                              },
                            },
                            [
                              _c(
                                "a-select",
                                {
                                  staticStyle: { width: "250px" },
                                  attrs: {
                                    placeholder: "请选择设备型号",
                                    allowClear: "",
                                  },
                                  on: { change: _vm.handleDeviceModelChange },
                                  model: {
                                    value: _vm.selectedDeviceModel,
                                    callback: function ($$v) {
                                      _vm.selectedDeviceModel = $$v
                                    },
                                    expression: "selectedDeviceModel",
                                  },
                                },
                                _vm._l(_vm.deviceModels, function (model) {
                                  return _c(
                                    "a-select-option",
                                    {
                                      key: model.deviceModel,
                                      attrs: { value: model.deviceModel },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            display: "inline-block",
                                            width: "80px",
                                          },
                                        },
                                        [_vm._v(_vm._s(model.modelName))]
                                      ),
                                      _c("span", [
                                        _vm._v(_vm._s(model.deviceDescription)),
                                      ]),
                                    ]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            [
                              _c(
                                "a-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    disabled: !_vm.selectedDeviceModel,
                                  },
                                  on: { click: _vm.handleAppStyle },
                                },
                                [
                                  _c("a-icon", { attrs: { type: "appstore" } }),
                                  _vm._v(" APP样式 "),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "formSlot",
                  fn: function () {
                    return [
                      _c(
                        "a-form-item",
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: ["effectName"],
                                expression: "['effectName']",
                              },
                            ],
                            staticStyle: {
                              width: "200px",
                              "margin-right": "10px",
                              "vertical-align": "middle",
                            },
                            attrs: { placeholder: "请输入场景名称" },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        [
                          _c(
                            "a-select",
                            {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: ["effectType"],
                                  expression: "['effectType']",
                                },
                              ],
                              staticStyle: {
                                width: "200px",
                                "margin-right": "10px",
                                "vertical-align": "middle",
                              },
                              attrs: {
                                placeholder: "请选择场景所属类别",
                                allowClear: "",
                              },
                            },
                            _vm._l(_vm.effectTypeList, function (item) {
                              return _c(
                                "a-select-option",
                                {
                                  key: item.effectType,
                                  attrs: { value: item.effectType },
                                },
                                [_vm._v(" " + _vm._s(item.effectType) + " ")]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        [
                          _c(
                            "a-select",
                            {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: ["effectVersion"],
                                  expression: "['effectVersion']",
                                },
                              ],
                              staticStyle: {
                                width: "200px",
                                "margin-right": "10px",
                                "vertical-align": "middle",
                              },
                              attrs: {
                                placeholder: "请选择光效应用版本",
                                allowClear: "",
                              },
                            },
                            _vm._l(_vm.effectVersionList, function (item) {
                              return _c(
                                "a-select-option",
                                {
                                  key: item.version,
                                  attrs: { value: item.version },
                                },
                                [_vm._v(" V" + _vm._s(item.version) + " ")]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "createTime",
                  fn: function (record) {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.dataFormatStr(
                              record.createTime,
                              "YYYY-MM-DD HH:mm:ss"
                            )
                          ) +
                          " "
                      ),
                    ]
                  },
                },
                {
                  key: "effectOrder",
                  fn: function (record) {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(_vm.formatEffectOrder(record.effectOrder)) +
                          " "
                      ),
                    ]
                  },
                },
                {
                  key: "effectVersion",
                  fn: function (record) {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            record.effectVersion
                              ? `V${record.effectVersion}`
                              : record.effectVersion
                          ) +
                          " "
                      ),
                    ]
                  },
                },
                {
                  key: "icon",
                  fn: function (record) {
                    return [
                      _c("img", { attrs: { width: "30", src: record.icon } }),
                    ]
                  },
                },
                {
                  key: "selectedIcon",
                  fn: function (record) {
                    return [
                      _c("img", {
                        attrs: { width: "30", src: record.selectedIcon },
                      }),
                    ]
                  },
                },
              ],
              null,
              false,
              1912464177
            ),
          })
        : _vm._e(),
      _c(
        "a-modal",
        {
          attrs: {
            title: "APP样式预览",
            visible: _vm.appStyleModalVisible,
            footer: null,
            width: "375px",
            bodyStyle: { padding: "0", backgroundColor: "#1a1a1a" },
            wrapClassName: "app-style-dark-modal",
          },
          on: { cancel: _vm.handleAppStyleCancel },
        },
        [
          _vm.appStyleData.length > 0
            ? _c("div", { staticClass: "dark-mode-container" }, [
                _c(
                  "div",
                  { staticClass: "tabs-navigation" },
                  _vm._l(_vm.appStyleData, function (group, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "tab-item",
                        class: { "tab-active": _vm.activeTabIndex === index },
                        on: {
                          click: function ($event) {
                            _vm.activeTabIndex = index
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(group.effectType) + " ")]
                    )
                  }),
                  0
                ),
                _c(
                  "div",
                  { staticClass: "content-grid" },
                  _vm._l(_vm.currentGroupItems, function (item) {
                    return _c(
                      "div",
                      {
                        key: item.serialNumber,
                        staticClass: "grid-item",
                        class: {
                          "grid-selected":
                            _vm.selectedSerialNumber === item.serialNumber,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.selectItem(item)
                          },
                        },
                      },
                      [
                        item.effectOrder &&
                        Array.isArray(item.effectOrder) &&
                        item.effectOrder.length > 1
                          ? _c("img", {
                              staticClass: "mult-effect-badge",
                              attrs: {
                                src: require("@/assets/images/icon/mult_effect_order.png"),
                              },
                            })
                          : _vm._e(),
                        _c("img", {
                          staticClass: "item-icon",
                          attrs: {
                            src:
                              _vm.selectedSerialNumber === item.serialNumber
                                ? item.selectedIcon
                                : item.icon,
                          },
                        }),
                        _c("span", { staticClass: "item-name" }, [
                          _vm._v(_vm._s(item.effectName)),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ])
            : _c("a-empty", {
                attrs: {
                  description: "暂无数据",
                  imageStyle: { filter: "invert(1)" },
                },
              }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }